import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-hero-d',
  styleUrl: 'hero-d.css',
  shadow: true,
})
export class HeroD {
  @Prop() titleWhiteText     : string;
  @Prop() titleYellowText    : string;
  @Prop() description        : string;
  @Prop() backgroundImage    : string;
  @Prop() backgroundPosition : string = 'center';
  @Prop() backgroundSize     : string = 'cover';
  @Prop() paddingTop         : string = '0';
  @Prop() height             : string = '840px';

  render() {
    return (
      <Host style={{
        height: this.height,
        paddingTop: this.paddingTop,
        backgroundImage: this.backgroundImage && `url(${this.backgroundImage})`,
        backgroundPosition: this.backgroundPosition,
        backgroundSize: this.backgroundSize,
      }}>
        <div>
          <h2>{this.titleWhiteText}<span>{this.titleYellowText}</span></h2>
          {this.description && <p>{this.description}</p>}
        </div>
      </Host>
    );
  }

}
